import * as Sift from '@sift/types';

interface Options {
  excludeChildNameFields?: boolean;
  whitelistObjectKeys?: string[];
}

// Returns whether a field should ever be returned as an option when configuring attribute list based settings
export default function isFieldValidConfigOption(field: Sift.Field, options: Options = {}) {
  if (options.whitelistObjectKeys && options.whitelistObjectKeys.includes(field.objectKey)) {
    return true;
  }

  // We should never present these as options. Need to blacklist for now since there's no intuitive way of filtering them out
  const CONFIG_OPTION_OBJECT_KEY_BLACKLIST = [
    'pronouns',
    'inclusivePronouns',
    'reportingPath',
    'teamLeaderId',
    'isTeamLeader',
    'hasNamePronunciation',
  ];

  const directParentFieldKey = field.objectKey.substring(0, field.objectKey.lastIndexOf('.'));

  // The field is a valid option if:
  // It is not blacklisted
  // AND
  //   It is not a child field
  //   OR
  //   It is a direct child of the reachOutToMeFor attribute
  //   OR
  //   Its objectKey ends with `.name` (This is a not so great check that covers relevant child fields for now, we should re-think this eventually)
  return (
    !CONFIG_OPTION_OBJECT_KEY_BLACKLIST.includes(field.objectKey) &&
    (!field.objectKey.includes('.') ||
      directParentFieldKey === 'reachOutToMeFor' ||
      (!options.excludeChildNameFields && field.objectKey.endsWith('.name')))
  );
}
